import React from 'react';
export function BigIdea() {
  return <section className="w-full bg-ink py-20 sm:py-28" data-id="element-20" data-mp="1vstwp7cd25n7">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-21" data-mp="2p9f06o6v1q54">
        <h2 className="font-serif text-3xl leading-snug sm:text-5xl sm:leading-[1.15] text-ivory" data-id="element-22" data-mp="2pc16kki0lzlr">
          The difference between a $500 planner and a $10,000 luxury planner isn&rsquo;t
          talent.
        </h2>
        <p className="mt-6 font-serif text-4xl italic sm:text-6xl text-gold" data-id="element-23" data-mp="21kdmalf9dmsg">
          It&rsquo;s the system.
        </p>
        <div className="rule-gold mx-auto mt-10 w-40" aria-hidden="true" data-id="element-24" data-mp="26ip0178ochfy" />
        <p className="mx-auto mt-10 max-w-2xl text-base sm:text-lg leading-relaxed text-ivory/70" data-id="element-25" data-mp="2bijn0zpbwmvq">
          Talent gets you the Pinterest boards. The system gets you the business. And until
          now, nobody handed you the system.
        </p>
      </div>
    </section>;
}